import { SVGProps } from "react";

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={15}
    height={14}
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.2587 2.8L10.2207 1L7.2207 2.734L4.2207 1L3.1827 2.8H1.2207V4.6H13.2207V2.8H11.2587ZM7.8207 5.2H12.6207V13H7.8207V5.2ZM1.8207 5.2H6.6207V13H1.8207V5.2Z"
      fill={props.fill || "#13CB75"}
    />
  </svg>
);

export default SVGComponent;
